<ng-container *ngIf="vm$ | async as vm">
  <app-dataset-card (click)="selectHomeElec(vm.unit)"
    [selected]="selected"
    [backgroundColor]="'var(--blue-10)'"
    [hoverBackgroundColor]="'var(--blue-5)'">
    <app-dataset-card-label>{{ 'legrand-app.__ELECTRICITY' | AsyncLang | async }}</app-dataset-card-label>
    <app-dataset-card-value class="text-blue">{{ vm[vm.unit]  | toDisplayValue : vm.measureType }}</app-dataset-card-value>
    <app-dataset-card-unit unit [measureType]="vm.measureType"></app-dataset-card-unit>
    <app-dataset-card-preview [home]="vm.home" [measureType]="vm.measureType"></app-dataset-card-preview>
  </app-dataset-card>

  <app-control-page-footer-consumption *ngIf="selected"></app-control-page-footer-consumption>
</ng-container>